// @erp/module-auth/fe/routes/student — the MEMBER portal's account doors
// (ADR-010 §2.12: self-registration and email verification for the reading
// gate). ONE BARREL PER SHELL — the admin barrel (../admin) carries the staff
// register; a shared barrel would drag one portal's factories into another's
// tsc program (the pass-2 lesson in AGENTS.md). Parent-generic (<TParent>) so
// the module never names a portal's Register-typed paths.
//
// Both routes carry a guarded `?next=` (../../next.ts validateNextSearch): a
// same-origin return path heals through, anything else heals to absent —
// never a router error for a link the website minted.
//
//   /register      — CHROMELESS (the portal's shell lists it beside /login);
//                    the details form, then the code, then `next`.
//   /verify-email  — CHROMED; signed-in; request → code → `next`.
import { createRoute } from "@tanstack/solid-router";
import { lazyRoute } from "@erp/ui/route-kit";
import { validateNextSearch } from "../../next.js";
import type { AnyRoute } from "@tanstack/solid-router";

export { validateNextSearch } from "../../next.js";
export type { NextSearch } from "../../next.js";

/**
 * Build the member-account subtree under the portal's root route. Returns the
 * routes to spread into `rootRoute.addChildren([...])` (router.tsx) beside the
 * OPAC and reader trees.
 */
export function makeAuthMemberRoutes<TParent extends AnyRoute>(rootRoute: TParent) {
  const registerRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: "/register",
    validateSearch: validateNextSearch,
  }).lazy(lazyRoute(() => import("../../screens/student/Register.js")));

  const verifyEmailRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: "/verify-email",
    validateSearch: validateNextSearch,
  }).lazy(lazyRoute(() => import("../../screens/student/VerifyEmail.js")));

  return [registerRoute, verifyEmailRoute];
}
